import {createImageObject} from '../utils';

export default {
    namespaced: true,
    state: {
        title: '智能扩图',
        suggestImg: [{
            url: 'https://feed-image.baidu.com/0/pic/-581327959_106460295_672488237.png',
            prompt: '相机',
            width: 212,
            height: 120
        }, {
            url: 'https://feed-image.baidu.com/0/pic/213070673_636444883_873248100.png',
            prompt: '椅子',
            width: 212,
            height: 120
        }, {
            url: 'https://feed-image.baidu.com/0/pic/225591998_1148778566_1197978346.png',
            prompt: '椅子',
            width: 212,
            height: 120
        }],
        historyParams: {
            pageNo: 1,
            pageSize: 10,
            taskType: [10]
        },
        sizeOptionIndex: 0,
        sizeObj: {
            ratio: null,
            width: 1140,
            height: 640
        },
        sizeObjPersonal: {
            width: 600,
            height: 600
        },
        canvasSize: {
            width: 600,
            height: 500
        },
        uploadImg: [],
        displayImg: [],
        recordImg: [],
        editLoading: false,
        toolBarLoading: false,
        ratioOptions: [
            {
                value: 'RATIO_16_9',
                label: '16:9'
            },
            {
                value: 'RATIO_9_16',
                label: '9:16'
            },
            {
                value: 'RATIO_4_3',
                label: '4:3'
            },
            {
                value: 'RATIO_3_4',
                label: '3:4'
            },
            {
                value: 'RATIO_1_1',
                label: '1:1'
            },
            {
                value: 'RATIO_3_1',
                label: '3:1'
            }
            // {
            //     value: 'RATIO_3_2',
            //     label: '3:2'
            // },
            // {
            //     value: 'RATIO_2_1',
            //     label: '2:1'
            // }
        ],
        sizeOptions: {
            'RATIO_1_1': [
                {
                    label: '600:600',
                    value: '600:600'
                },
                {
                    label: '240:240',
                    value: '240:240'
                },
                {
                    label: '220:220',
                    value: '220:220'
                },
                {
                    label: '360:360',
                    value: '360:360'
                },
                {
                    label: '480:480',
                    value: '480:480'
                },
                {
                    label: '300:300',
                    value: '300:300'
                }
            ],
            'RATIO_3_1': [
                {
                    label: '1200:400',
                    value: '1200:400'
                },
                {
                    label: '900:300',
                    value: '900:300'
                }
            ],
            'RATIO_16_9': [
                {
                    label: '1140:640',
                    value: '1140:640'
                },
                {
                    label: '1280:720',
                    value: '1280:720'
                },
                {
                    label: '1600:900',
                    value: '1600:900'
                },
                {
                    label: '1920:1080',
                    value: '1920:1080'
                }
            ],
            'RATIO_4_3': [
                {
                    label: '800:600',
                    value: '800:600'
                },
                {
                    label: '120:90',
                    value: '120:90'
                }
            ],
            'RATIO_3_4': [
                {
                    label: '600:800',
                    value: '600:800'
                }
            ],
            'RATIO_9_16': [
                {
                    label: '1080:1920',
                    value: '1080:1920'
                },
                {
                    label: '1242:2208',
                    value: '1242:2208'
                },
                {
                    label: '720:1280',
                    value: '720:1280'
                }
            ],
            'RATIO_3_2': [
                {
                    label: '370:245',
                    value: '370:245'
                },
                {
                    label: '960:640',
                    value: '960:640'
                },
                {
                    label: '1200:800',
                    value: '1200:800'
                },
                {
                    label: '900:600',
                    value: '900:600'
                },
                {
                    label: '300:200',
                    value: '300:200'
                }
            ],
            'RATIO_2_1': [
                {
                    label: '800:400',
                    value: '800:400'
                },
                {
                    label: '600:300',
                    value: '600:300'
                }
            ]
        }
    },
    mutations: {
        CHANGE_SIZE_OPTION_INDEX(state, data) {
            state.sizeOptionIndex = data;
        },
        CHANGE_SIZE(state, data) {
            state.sizeObj.ratio = data.ratio || null;
            state.sizeObj.width = data.width || '';
            state.sizeObj.height = data.height || '';
        },
        CHANGE_SIZE_PERSONAL(state, data) {
            state.sizeObjPersonal = data;
        },
        CHANGE_CANVAS_SIZE(state, data) {
            state.canvasSize = data;
        },
        CHANGE_UPLOAD_IMG(state, data) {
            state.uploadImg = data;
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_EDIT_LOADING(state, data) {
            state.editLoading = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        }
    },
    actions: {
        changeSizeOptionIndex({commit}, data) {
            commit('CHANGE_SIZE_OPTION_INDEX', data);
        },
        changeSize({commit}, data) {
            commit('CHANGE_SIZE', data);
        },
        changeSizePersonal({commit}, data) {
            commit('CHANGE_SIZE_PERSONAL', data);
        },
        changeCanvasSize({commit}, data) {
            commit('CHANGE_CANVAS_SIZE', data);
        },
        changeUploadImg({commit}, data) {
            commit('CHANGE_UPLOAD_IMG', data);
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    const recordList = i.records;
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片上传 获取主体
        async handleImagePickerConfirm({commit, state}, info) {
            const {model, res} = info;
            const {data = []} = res;
            const imgData = data[0] || [];
            const imgRes = imgData[0] || [];
            const width = state.sizeOptionIndex === 0 ? state.sizeObj.width : state.sizeObjPersonal.width;
            const height = state.sizeOptionIndex === 0 ? state.sizeObj.height : state.sizeObjPersonal.height;
            const uploadImg = imgRes.map(item => {
                let ratio = 1;
                let fgW;
                let fgH;
                if (width / height < item.width / item.height) {
                    ratio = item.height / item.width;
                    fgW = width;
                    fgH = Math.floor(width * ratio);
                }
                else {
                    ratio = item.width / item.height;
                    fgW = Math.floor(height * ratio);
                    fgH = height;
                }
                return {
                    url: item.url,
                    prompt: '',
                    width: item.width,
                    height: item.height,
                    posX: 0,
                    posY: 0,
                    fgW,
                    fgH
                };
            });
            const allUploadImg = state.uploadImg.concat(uploadImg);
            commit('CHANGE_UPLOAD_IMG', allUploadImg);
        },
        // 扩图按钮提交
        async handleExpandSubmit({commit, state}, model) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const baseDisplayImg = state.uploadImg.map((_, index) => createImageObject({recordId: index}));
                commit('CHANGE_DISPLAY_IMG', baseDisplayImg);

                const width = state.sizeOptionIndex === 0 ? state.sizeObj.width : state.sizeObjPersonal.width;
                const height = state.sizeOptionIndex === 0 ? state.sizeObj.height : state.sizeObjPersonal.height;

                const ratioX = width / state.canvasSize.width;
                const ratioY = height / state.canvasSize.height;

                const itemParams = state.uploadImg.map(i => ({
                    count: 1, // 每张图只生成1张扩图结果
                    desc: i.prompt,
                    url: i.url,
                    posX: i.resize ? Math.floor(i.posX * ratioX) || 0 : Math.floor((width - i.fgW) / 2),
                    posY: i.resize ? Math.floor(i.posY * ratioY) || 0 : Math.floor((height - i.fgH) / 2),
                    fgW: Math.min(i.resize ? Math.floor(i.fgW * ratioX) : i.fgW, width),
                    fgH: Math.min(i.resize ? Math.floor(i.fgH * ratioY) : i.fgH, height)
                }));
                const params = {
                    width,
                    height,
                    originImageList: itemParams
                };
                let displayImg = [];
                await model.imageCreate.expandImage(params, data => {
                    if (!data.records?.length) {
                        return;
                    }
                    if (data.taskStatus === 2) {
                        displayImg = data.records.map(item => createImageObject({
                            url: item.url,
                            recordId: item.recordId,
                            width,
                            height
                        }));
                    }
                    else {
                        displayImg = state.displayImg.map((i, index) => {
                            let item = data.records[index];
                            if (!item) {
                                return i;
                            }
                            return createImageObject({
                                url: item.url,
                                recordId: item.recordId,
                                width,
                                height
                            });
                        });
                    }
                    commit('CHANGE_DISPLAY_IMG', displayImg);
                });
            }
            catch (err) {
                console.error(err.message);
                throw err;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        }
    },
    getters: {
    }
};
